import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import couterpart from 'counterpart';
import { ToastsContainer, ToastsStore } from 'react-toasts';

import { withRouter } from 'react-router-dom';

import AuthenticationService from '../services/AuthenticationService';
import MenuComponent2 from './MenuComponent2';
// import ReactTablePagination from './PaginationComponent';
import UserDataService from '../services/UserDataService';
import "../css/style.css";
import WorkOrderUtil from '../utilities/WorkOrderUtil';

import { MdDeleteForever, MdModeEdit } from 'react-icons/md';
import { IoIosPersonAdd } from 'react-icons/io';

import { ICON_COLOR } from '../icon';
import { FaFilter } from 'react-icons/fa';

class UserList extends Component {
  constructor() {
    super();
    const user_id = couterpart.translate('user_id');
    const user_username = couterpart.translate('user_username');
    const user_firstname = couterpart.translate('user_firstname');
    const user_lastname = couterpart.translate('user_lastname');
    const user_action = couterpart.translate('user_action');
    const user_working_shop = couterpart.translate('user_working_shop');
    const user_isActive = couterpart.translate('user_isActive');

    this.state = {
      viewAll: 0,
      count: 0,
      users: [],
      columns: [{
        Header: user_id,
        accessor: 'id'
      }, {
        Header: user_username,
        accessor: 'userName',
      }, {
        Header: user_firstname,
        accessor: 'firstName'
      }, {
        Header: user_lastname,
        accessor: 'lastName'
      }, {
        Header: user_working_shop,
        accessor: 'workingShop'
      }, {
        Header: user_isActive,
        accessor: 'isActive'
      }, {
        Header: user_action,
        accessor: 'action',
        width: 150,
        Cell: row => (
          this.getFunctionButtons(row)
        )
      }]
    };
  }

  getFunctionButtons(row) {
    if (AuthenticationService.isAdmin()) {
      const button_edit = couterpart.translate('button_edit');
      
      let button_caption = "";
      if (row.original.isActive == 0){
        button_caption = couterpart.translate('button_activate');
      } else {
        button_caption = couterpart.translate('button_deactivate');
      }

      return (
        <div style={{ textAlign: "center" }}>
          <button className="myButton" onClick={() => this.handleEdit(row.original)}>
            <MdModeEdit color={ICON_COLOR} />&nbsp;
            {button_edit}</button>&nbsp;
          <button className="myButton" onClick={() => this.handleDelete(row.original)}>
            <MdDeleteForever color={ICON_COLOR} />&nbsp;
            {button_caption}</button>
        </div>
      )
    } else {
      return (<div>&nbsp;</div>)
    }
  }

  componentDidMount() {
    let tmp = WorkOrderUtil.getItem('users.selectedPage');
    let iSelectPage = 0;
    if (tmp !== undefined) {
      iSelectPage = parseInt(tmp);
    }
    UserDataService.retrieveUsersBy(this.state.viewAll).then(data => {
      let selected = WorkOrderUtil.getItem('users.selectedRow') ? parseInt(WorkOrderUtil.getItem('users.selectedRow')) : 0;
      if (data.message === undefined) {
        this.setState({ users: data, selectedRow: selected, selectedPage: iSelectPage })
      } else {
        this.setState({ users: [], selectedRow: selected, selectedPage: iSelectPage })
        ToastsStore.error(data.message);
      }
    });
  }

  handleEdit(e) {
    let url = "/users/edit/" + (e.id !== undefined ? e.id : 0);
    this.setState({ action: 'EDIT' }, () => {
      this.props.history.push(url);
    });
  }

  handleDelete(e) {
    UserDataService.delete(e.id).then(data => {
      if (data.message === undefined) {
        UserDataService.retrieveUsers().then(data => {
          this.setState({ users: data })
        });
      }
    });
  }

  handleChangeStatus(e) {
    this.setState({ action: 'ADD' }, () => {
      this.props.history.push("/users/add");
    });
  }

  handleChange(e) {
    var value = e.target.value;
    if (value === undefined || value.length < 1) {
      this.setState({
        searchValue: ''
      });
    }
    else {
      this.setState(prevState => ({
        searchValue: value
      }));
    }
  }

  onFilter(){
    let iSelectPage = 0;
    UserDataService.retrieveUsersByNameAndViewAll(this.state.searchValue, this.state.viewAll).then(data => {
      let selected = WorkOrderUtil.getItem('users.selectedRow') ? parseInt(WorkOrderUtil.getItem('users.selectedRow')) : 0;
      if (data.message === undefined) {
        this.setState({ users: data, selectedRow: selected, selectedPage: iSelectPage })
      } else {
        this.setState({ users: [], selectedRow: selected, selectedPage: iSelectPage })
        ToastsStore.error(data.message);
      }
    });
  }

  handleViewAllClick() {
    if (this.state.viewAll == 1) {
      this.setState({ viewAll: 0 });
    } else {
      this.setState({ viewAll: 1 });
    }
  }

  render() {
    if (!AuthenticationService.isAdmin()) {
      return (<div>Unauthorized access.</div>);
    }
    const button_add = couterpart.translate('button_add');
    return (
      <div>
        <MenuComponent2 />
        <ToastsContainer store={ToastsStore} position="bottom_center" />
        <div className="row">
          <div className="col-2">
            <button name="Add" className="myButton"
              onClick={this.handleEdit.bind(this)}>
              <IoIosPersonAdd color={ICON_COLOR} />&nbsp;
              {button_add}</button>
          </div>
          <div className="col-2">
            <input type="text" defaultValue={this.state.searchValue} placeholder={ "Tên" } onChange={this.handleChange.bind(this)} style={{ margin: "5px", width: "100%" }} />
          </div>
          <div className='col-2'>
            <input type="checkbox" value={1} checked={this.state.viewAll == 1 ? true : false} onChange={this.handleViewAllClick.bind(this)}  style={{ margin: "15px" }} id="viewAll" /> &nbsp;{couterpart.translate('view_all')}
          </div>
          <div className="col-2">
            <button className="myButton" onClick={this.onFilter.bind(this)}><FaFilter color={ICON_COLOR} />&nbsp;{couterpart.translate('button_filter')}</button>
          </div>
        </div>
        <ReactTable
          NoDataComponent={() => null}
          // PaginationComponent={ReactTablePagination}
          previousText={"<"}
          nextText={">"}
          data={this.state.users}
          columns={this.state.columns}
          defaultPageSize={10}
          showPageSizeOptions={true}
          page={this.state.selectedPage}
          onPageChange={(pageIndex) => {
            this.setState({ selectedPage: pageIndex })
            WorkOrderUtil.saveItem('users.selectedPage', pageIndex)
          }}
          pageSizeOptions={[3, 5, 10, 20]}
          getTrProps={(state, rowInfo, column) => {
            if (rowInfo && rowInfo.row) {
              return {
                onClick: (e) => {
                  this.setState({
                    selectedRow: rowInfo.index,
                    itemId: rowInfo.original.id
                  }, () => {
                    WorkOrderUtil.saveItem('users.selectedRow', this.state.selectedRow);
                  })
                },
                style: {
                  background: rowInfo.index === this.state.selectedRow ? '#DCDCDC' : 'white',
                  color: rowInfo.index === this.state.selectedRow ? 'white' : 'black'
                }
              }
            } else {
              return {}
            }
          }
          }
        />
      </div>
    )
  }
}

export default withRouter(UserList);